import later from 'later/index-browserify.js'
import bus from 'src/eventbus'

// default UTC time
later.date.UTC()

// store.watch((state) => {
//   return Math.ceil(state.timegap.localServerTimeGap / 1000)
// }, (timegap) => {
//   later.date.build = function(Y, M, D, h, m, s) {
//     console.log(Y, M, D, h, m, s)
//     return new Date(Date.UTC(Y, M, D, h, m, s) - timegap)
//   }
// })
/**
 * Crontab Plugin
 *
 * Usage:
 *
 * // Refresh every 10sec on 8am to 4pm at workday
 * this.timer = this.$cron('∗/10 * 8-16 * * 1-5').interval(INDICIES_REFRESH_TIMER, () => {
 *  this.$store.dispatch('refreshIndices')
 * })
 *
 * destroyed () {
 *   this.clear()
 * }
 */
export default {
  install(Vue) {
    const jobList = {}
    /**
     * TODO: If task returns a Promise, it will wait
     * for the Promise to finish before scheduling the next job.
     *
     * @param {String} schedule cron format https://en.wikipedia.org/wiki/Cron
     * *    *    *    *    *    *
     * ┬    ┬    ┬    ┬    ┬    ┬
     * │    │    │    │    │    |
     * │    │    │    │    │    └ day of week (0 - 7) (0 or 7 is Sun)
     * │    │    │    │    └───── month (1 - 12)
     * │    │    │    └────────── day of month (1 - 31)
     * │    │    └─────────────── hour (0 - 23)
     * │    └──────────────────── minute (0 - 59)
     * └───────────────────────── second (0 - 59, optional)
     * @param {Object} schedule https://bunkat.github.io/later/schedules.html
     *
     * @param {Function} taskFn
     * @return {Object} timer handler
     */
    Vue.prototype.$cron = function(schedule, always = false) {
      let sched

      if (typeof schedule === 'string') {
        sched = later.parse.cron(schedule, true)
      } else if (typeof schedule === 'object') {
        // schedule is Object or Array
        sched = schedule
      } else {
        throw new Error(
          `Param schedule is invalid${
            this.$options.name ? ' in component ' + this.$options.name : '.'
          } `
        )
      }

      const wrap = timer => {
        timer.pause = function() {
          timer.isPaused = true
          return timer
        }
        timer.resume = function() {
          timer.isPaused = false
          return timer
        }
        return timer
      }

      const setExecute = (type, name, fn) => {
        // Renew exist timer if named timer exists
        if (jobList[name]) {
          jobList[name].clear()
          jobList[name] = null
        }

        if (typeof name === 'string') {
          jobList[name] = later[type](function() {
            if (!jobList[name].isPaused) {
              fn()
            }
          }, sched)
        }

        const timer = wrap(jobList[name])

        // Cache timer
        let cacheStatus = timer.isPaused
        if (!always) {
          bus.addListener(
            bus.$events.DOCUMENT_VISIBLE_CHANGE,
            ({ visible }) => {
              if (visible) {
                timer.isPaused = cacheStatus
              } else {
                cacheStatus = timer.isPaused
                timer.isPaused = true
              }
            }
          )
        }

        // Returns the last one if the name of timer exist
        // Returns undefined if name is invalid
        return timer
      }

      return {
        timeout: setExecute.bind(this, 'setTimeout'),
        interval: setExecute.bind(this, 'setInterval')
      }
    }

    /**
     * Return the timer
     */
    Vue.prototype.$cron.get = function(name) {
      return jobList[name]
    }

    /**
     * Clear all jobs
     */
    Vue.prototype.$cron.clearAll = function() {
      for (const name in jobList) {
        jobList[name].clear()
        jobList[name] = undefined
      }
    }

    /**
     * Clear one job
     */
    Vue.prototype.$cron.clear = function(name) {
      if (jobList[name]) {
        jobList[name].clear()
        jobList[name] = undefined
      }
    }
  }
}
